export default __webpack_public_path__ + "static/media/nordst.8043234b.png";